import { ProductAddonListPage } from '@/features/product-addon/pages/ProductAddonListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-addon/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_addon.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAddonListPage,
})
